<template>
  <v-container v-if="permitted == false && permitted != null" class="pt-0" fluid>
    <v-dialog v-model="permitted_dialog" max-width="400px">
      <v-card>
        <v-card-text>
          <div class="text-center">
            <div class="title font-weight-light pt-2"><v-icon class="mr-1">mdi-shield-lock-outline</v-icon>Security Error</div>
            <p>{{message}}</p>
            <v-progress-circular
              :size="70"
              :width="2"
              :value="100"
              color="error"
              class="mb-4 mr-4"
            >
              <v-icon color="red" x-large>mdi-exclamation-thick</v-icon>
            </v-progress-circular>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
  <v-container v-else v-show="permitted != null" class="pt-0" fluid>
    <v-snackbar
      :value="showMessage()"
      multi-line
      color="#686868"
      top
      
    >
      {{message}}
    </v-snackbar>
    <v-card flat >
    <v-toolbar dense flat color="#2A353D">
      <v-toolbar-title class="white--text subtitle-1 font-weight-normal">Clients</v-toolbar-title>
      <v-spacer/>
      <v-btn fab x-small outlined color="#81DBF6" class="mr-1" v-if="edit == true || create == true" @click="view = false; closeCreate(); closeEdit()"><v-icon>mdi-chevron-left</v-icon></v-btn>
      <v-btn fab x-small outlined color="#81DBF6" @click="$router.push('/Home')"><v-icon>mdi-close</v-icon></v-btn>
    </v-toolbar>
    </v-card>

<!-- ********************************************************************************************CREATE**************************************************************************************************
***************************************************************************************************************************************************************************************************** -->
    <v-form flat color="#ffffff00" v-if="create">

      <v-stepper v-model="e1">
        <v-stepper-header class="elevation-0">
          <v-stepper-step
            :rules="[() => step1_valid]"
            :complete="e1 > 1"
            step="1"
          >
            Client Details
          </v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step
            :rules="[() => step2_valid]"
            :complete="e1 > 2"
            step="2"
          >
            Contact Details
          </v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step
            :rules="[() => step3_valid]"
            :complete="e1 > 3"
            step="3"
          >
            Bank Details
          </v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step
            :rules="[() => step4_valid]"
            :complete="e1 > 4"
            step="4"
          >
            Management
          </v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step
            :rules="[() => step5_valid]"
            :complete="e1 > 5"
            step="5"
          >
            Additional
          </v-stepper-step>
        </v-stepper-header>

        <v-stepper-items>
          <v-stepper-content step="1">
            <v-form ref="step_1" v-model="step1_valid" lazy-validation elevation="12">
              <v-row class="ml-1 mr-1">
                <v-col class="pb-0">
                  <v-select
                    outlined dense
                    v-model="Client.Classification"
                    :items="Classifications"
                    item-text="class"
                    item-value="class"
                    placeholder="----"
                    :rules="TextFieldRules"
                    label="Client Classification"
                  ></v-select>
                  <v-text-field
                    light dense outlined
                    color="#2A353D"
                    v-model="Client.MajorName"
                    :label="Client.Classification == 'Individual' ? 'Surname' : Client.Classification == 'Corporate' ? 'Corporate Name' : 'Institution Name'"
                    required
                    :rules="[
                      v => !!v || 'field is required',
                      v => (v && v.length <= 150) || 'field must be less than 150 characters'
                    ]"
                    placeholder="----"
                  ></v-text-field>
                  <v-text-field
                    light dense outlined
                    color="#2A353D"
                    v-model="Client.Forename"
                    :label="Client.Classification == 'Individual' ? 'Forename' : 'Trade Name'"
                    required
                    :rules="[
                      v => v ? (v && v.length <= 150) || 'field must be less than 150 characters' : null
                    ]"
                    placeholder="----"
                  ></v-text-field>
                  <v-text-field
                    light dense outlined
                    color="#2A353D"
                    v-model="Client.IDNumber"
                    :label="Client.Classification == 'Individual' ? 'ID Number' : 'Registration/Identification Number'"
                    required
                    :rules="[
                      v => !!v || 'field is required',
                      v => (v && v.length <= 50) || 'field must be less than 50 characters'
                    ]"
                    placeholder="----"
                  ></v-text-field>
                  <v-text-field
                    light dense outlined
                    color="#2A353D"
                    v-model="Client.ExternalRef"
                    label="CSD Number"
                    required
                    placeholder="----"
                  ></v-text-field>
                </v-col>

                <v-col :class="Client.Classification == 'Individual'? 'pb-0':'pb-0 mt-12 pt-7'">
                  <v-text-field
                    light dense outlined
                    color="#2A353D"
                    label="CIF Number"
                    disabled
                    placeholder="----"
                  ></v-text-field>
                  <v-select
                    v-if="Client.Classification == 'Individual'"
                    outlined dense
                    v-model="Client.Gender"
                    :items="Gender"
                    item-text="title"
                    item-value="title"
                    placeholder="----"
                    :rules="TextFieldRules"
                    label="Gender"
                  ></v-select>
                  <v-select
                    v-else
                    outlined dense
                    v-model="Client.ClientTypeID"
                    :items="Client.Classification == 'Corporate' ? allClientTypes.filter(a => CorporateCategories.includes(a.ClientTypeID) == true && a.CheckerID != 0 && a.RejectionID == 0) : allClientTypes.filter(a => InstitutionCategories.includes(a.ClientTypeID) == true && a.CheckerID != 0 && a.RejectionID == 0)"
                    item-text="ClientType"
                    item-value="ClientTypeID"
                    placeholder="----"
                    :rules="TextFieldRules"
                    label="Client Category"
                  ></v-select>
                  <v-select
                    v-if="Client.Classification == 'Individual'"
                    outlined dense
                    v-model="Client.TitleID"
                    :items="allTitles.filter(a => a.CheckerID != 0 && a.RejectionID == 0)"
                    item-text="Title"
                    item-value="TitleID"
                    placeholder="----"
                    :rules="TextFieldRules"
                    label="Title"
                  ></v-select>
                  <v-select
                    outlined dense
                    v-model="Client.IdentityTypeID"
                    :items="Client.Classification == 'Individual'? allIdentityTypes.filter(a => a.CategoryID == 6 && a.CheckerID != 0 && a.RejectionID == 0) : IdentityTypes.filter(a => (a.CategoryID == Client.ClientTypeID || a.CategoryID == 0) && a.CheckerID != 0 && a.RejectionID == 0)"
                    item-text="IdentityType"
                    item-value="IdentityTypeID"
                    placeholder="----"
                    label="Identity type"
                  ></v-select>
                  <v-menu
                    ref="menu"
                    v-model="menu"
                    :close-on-content-click="false"
                    :return-value.sync="DateOfBirth"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="DateOfBirth"
                        :label="Client.Classification == 'Individual'? 'Date of Birth':'Registered Date'"
                        append-icon="mdi-calendar-month"
                        readonly placeholder="--/--/--"
                        dense outlined color="#2A353D"
                        :rules="TextFieldRules"
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker color="#2A353D" v-model="DateOfBirth" no-title scrollable>
                    <v-spacer></v-spacer>
                    <v-btn outlined small color="#2A353D" @click="menu = false">Cancel</v-btn>
                    <v-btn outlined small color="#2A353D" @click="$refs.menu.save(DateOfBirth)">OK</v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
              <span class="d-flex flex-row my-4">
                <v-spacer/>
                <v-btn disabled outlined color="#2A353D" x-small fab><v-icon>mdi-chevron-left</v-icon></v-btn>
                <v-btn class="mx-2" @click="validateStep_1()" outlined color="#2A353D" x-small fab><v-icon>mdi-chevron-right</v-icon></v-btn>
                <v-btn class="white--text" small color="#2A353D" @click="closeCreate()">close</v-btn>
              </span>
            </v-form>
          </v-stepper-content>

          <v-stepper-content step="2">
            <v-form ref="step_2" v-model="step2_valid" lazy-validation elevation="12">
              <v-row class="ml-1 mr-1">
                <v-col class="pb-0">
                  <v-card class="pa-5 pt-2">
                    <span class="caption">Physical Address</span>
                    <v-text-field
                      light dense
                      color="#2A353D"
                      v-model="Client.Physical_Address_1"
                      required
                      :readonly="view"
                      :rules="TextFieldRules"
                    ></v-text-field>
                    <v-text-field
                      light dense
                      color="#2A353D"
                      v-model="Client.Physical_Address_2"
                      required
                      :readonly="view"
                    ></v-text-field>
                    <v-text-field
                      light dense
                      color="#2A353D"
                      v-model="Client.Physical_Address_3"
                      required
                      :readonly="view"
                    ></v-text-field>
                    <v-select
                      filled dense
                      v-model="Client.Physical_CountryId"
                      :items="allCountries.filter(a => a.CheckerID != 0 && a.RejectionID == 0)"
                      item-text="CountryName"
                      item-value="CountryId"
                      label="Country"
                      :readonly="view"
                      :rules="TextFieldRules"
                    ></v-select>
                    <v-select
                      filled dense
                      v-model="Client.Physical_CityID"
                      :items="allCities.filter(a => a.CountryId == Client.Physical_CountryId && a.CheckerID != 0 && a.RejectionID == 0)"
                      item-text="City"
                      item-value="CityID"
                      label="City"
                      :readonly="view"
                      :rules="TextFieldRules"
                    ></v-select>
                  </v-card>
                </v-col>
                <v-col class="pb-0">
                  <v-card v-if="SyncAddress == false" class="pa-5 pt-2">
                    <span class="caption">Postal Address</span>
                    <v-text-field
                      light dense
                      color="#2A353D"
                      v-model="Client.Postal_Address_1"
                      required
                      :readonly="view"
                      :rules="TextFieldRules"
                    ></v-text-field>
                    <v-text-field
                      light dense
                      color="#2A353D"
                      v-model="Client.Postal_Address_2"
                      required
                      :readonly="view"
                    ></v-text-field>
                    <v-text-field
                      light dense
                      color="#2A353D"
                      v-model="Client.Postal_Address_3"
                      required
                      :readonly="view"
                    ></v-text-field>
                    <v-select
                      filled dense
                      v-model="Client.Postal_CountryId"
                      :items="allCountries.filter(a => a.CheckerID != 0 && a.RejectionID == 0)"
                      item-text="CountryName"
                      item-value="CountryId"
                      label="Country"
                      :readonly="view"
                      :rules="TextFieldRules"
                    ></v-select>
                    <v-select
                      filled dense
                      v-model="Client.Postal_CityID"
                      :items="allCities.filter(a => a.CountryId == Client.Postal_CountryId && a.CheckerID != 0 && a.RejectionID == 0)"
                      item-text="City"
                      item-value="CityID"
                      label="City"
                      :readonly="view"
                      :rules="TextFieldRules"
                    ></v-select>
                  </v-card>

                  <v-card v-else class="pa-5 pt-2">
                    <span class="caption">Postal Address</span>
                    <v-text-field
                      light dense
                      color="#2A353D"
                      v-model="Client.Physical_Address_1"
                      required
                      :readonly="view"
                      :rules="TextFieldRules"
                    ></v-text-field>
                    <v-text-field
                      light dense
                      color="#2A353D"
                      v-model="Client.Physical_Address_2"
                      required
                      :readonly="view"
                    ></v-text-field>
                    <v-text-field
                      light dense
                      color="#2A353D"
                      v-model="Client.Physical_Address_3"
                      required
                      :readonly="view"
                    ></v-text-field>
                    <v-select
                      filled dense
                      v-model="Client.Physical_CountryId"
                      :items="allCountries.filter(a => a.CheckerID != 0 && a.RejectionID == 0)"
                      item-text="CountryName"
                      item-value="CountryId"
                      label="Country"
                      :readonly="view"
                      :rules="TextFieldRules"
                    ></v-select>
                    <v-select
                      filled dense
                      v-model="Client.Physical_CityID"
                      :items="allCities.filter(a => a.CountryId == Client.Physical_CountryId && a.CheckerID != 0 && a.RejectionID == 0)"
                      item-text="City"
                      item-value="CityID"
                      label="City"
                      :readonly="view"
                      :rules="TextFieldRules"
                    ></v-select>
                  </v-card>
                </v-col>
                <v-col class="pb-0">
                  <v-text-field
                    light dense outlined
                    color="#2A353D"
                    v-model="Client.Email"
                    label="Email"
                    :readonly="view"
                    :rules="Client.Email == null ? '' : emailRules"
                    placeholder="----"
                  ></v-text-field>
                  <v-text-field
                    light dense outlined
                    color="#2A353D"
                    v-model="Client.MobileNumber"
                    label="Mobile Number"
                    required
                    type="number"
                    :readonly="view"
                    :rules="Client.MobileNumber == null ? '' : MobileRules"
                    placeholder="----"
                  ></v-text-field>
                  <v-text-field
                    light dense outlined
                    color="#2A353D"
                    v-model="Client.Telephone1"
                    label="Telephone #1"
                    :readonly="view"
                    placeholder="----"
                  ></v-text-field>
                  <v-text-field
                    light dense outlined
                    color="#2A353D"
                    v-model="Client.Telephone2"
                    label="Telephone #2"
                    :readonly="view"
                    placeholder="----"
                  ></v-text-field>
                  <v-select
                    light dense outlined
                    v-model="Client.Nationality"
                    :items="allCountries.filter(a => a.CheckerID != 0 && a.RejectionID == 0)"
                    item-text="Nationality"
                    item-value="CountryId"
                    label="Nationality"
                    placeholder="----"
                    :rules="TextFieldRules"
                  ></v-select>
                </v-col>
              </v-row>

              <v-row class="ml-1 mr-1">
                <v-col cols="8">
                  <div class="text-center">
                    <v-btn @click="syncPostalAddress()" block outlined rounded color="#2A353D" class="pr-3" v-on="on">
                      Make Postal address the same as the Physical address<v-icon class="ml-1">mdi-cached</v-icon>
                    </v-btn>
                  </div>
                </v-col>
              </v-row>
              <v-divider/>
              <span class="d-flex flex-row my-4">
                <v-spacer/>
                <v-btn @click="e1 = 1" outlined color="#2A353D" x-small fab><v-icon>mdi-chevron-left</v-icon></v-btn>
                <v-btn class="mx-2" @click="validateStep_2()" outlined color="#2A353D" x-small fab><v-icon>mdi-chevron-right</v-icon></v-btn>
                <v-btn class="white--text" small color="#2A353D" @click="closeCreate()">close</v-btn>
              </span>
            </v-form>
          </v-stepper-content>

          <v-stepper-content step="3">
            <v-form ref="step_3" v-model="step3_valid" lazy-validation elevation="12">
              <v-row class="ml-1 mr-1">
                <v-col class="pb-0">
                  <v-select
                    outlined dense
                    v-model="Client.BankID"
                    :items="allBanks.filter(a => a.CheckerID != 0 && a.RejectionID == 0)"
                    item-text="Bank"
                    item-value="BankID"
                    placeholder="----"
                    :rules="TextFieldRules"
                    label="Bank"
                  ></v-select>
                  <v-text-field
                    light dense outlined
                    color="#2A353D"
                    v-model="Client.BankAccNumber"
                    label="Account Number"
                    required
                    :rules="[
                      v => !!v || 'field is required',
                      v => (v && v.length <= 40) || 'field must be less than 40 characters'
                    ]"
                    placeholder="----"
                  ></v-text-field>
                  <v-select
                    outlined dense
                    v-model="Client.BankAccountTypeID"
                    :items="allBankAccountTypes.filter(a => a.CheckerID != 0 && a.RejectionID == 0)"
                    item-text="BankAccountType"
                    item-value="BankAccountTypeID"
                    placeholder="----"
                    :rules="TextFieldRules"
                    label="Account Type"
                  ></v-select>
                </v-col>
                <v-col class="pb-0">
                  <v-select
                    outlined dense
                    v-model="Client.BranchID"
                    :items="allBankBranches.filter(a => a.BankID == Client.BankID && a.CheckerID != 0 && a.RejectionID == 0)"
                    item-text="BranchName"
                    item-value="BranchID"
                    placeholder="----"
                    :rules="TextFieldRules"
                    label="Branch"
                  ></v-select>
                  <v-text-field
                    light dense outlined
                    color="#2A353D"
                    v-model="Client.BankAccName"
                    label="Account Name"
                    required
                    :rules="[
                      v => !!v || 'field is required',
                      v => (v && v.length <= 50) || 'field must be less than 50 characters'
                    ]"
                    placeholder="----"
                  ></v-text-field>
                </v-col>
              </v-row>
              <span class="d-flex flex-row my-4">
                <v-spacer/>
                <v-btn @click="e1 = 2" outlined color="#2A353D" x-small fab><v-icon>mdi-chevron-left</v-icon></v-btn>
                <v-btn class="mx-2" @click="validateStep_3()" outlined color="#2A353D" x-small fab><v-icon>mdi-chevron-right</v-icon></v-btn>
                <v-btn class="white--text" small color="#2A353D" @click="closeCreate()">close</v-btn>
              </span>
            </v-form>
          </v-stepper-content>

          <v-stepper-content step="4">
            <v-form ref="step_4" v-model="step4_valid" lazy-validation elevation="12">
              <v-row class="ml-1 mr-1">
                <v-col class="pb-0">
                  <v-textarea
                    class="mb-0"
                    label="Standing Instructions"
                    v-model="Client.StandingInstructions"
                    outlined
                    rows="6"
                    placeholder="No standing instruction"
                    row-height="15"
                  ></v-textarea>
                </v-col>
                <v-col class="pb-0">
                  <v-select
                    outlined dense
                    v-model="Client.CustodianID"
                    :items="allCustodians.filter(a => a.ProfileType != 3 && a.CheckerID != 0 && a.RejectionID == 0)"
                    item-text="CustodianName"
                    item-value="CustodianID"
                    placeholder="----"
                    :rules="TextFieldRules"
                    label="Custodianship/Trading Acc"
                  ></v-select>
                  <v-select
                    outlined dense
                    v-model="Client.ClientGroupId"
                    :items="allCustodians.filter(a => a.ProfileType == 3 && a.CheckerID != 0 && a.RejectionID == 0)"
                    item-text="CustodianName"
                    item-value="CustodianID"
                    placeholder="----"
                    label="Client Group"
                  ></v-select>
                  <v-select
                    outlined dense
                    v-model="Client.ConsultantID"
                    :items="Consultants"
                    item-text="CustodianName"
                    item-value="CustodianID"
                    placeholder="----"
                    label="Administrator"
                  ></v-select>
                </v-col>
              </v-row>
              <v-row class="ml-1 mr-1">
                <v-col class="pb-0 pt-0">
                  <v-row>
                    <v-col class="pb-0 pt-0">
                      <v-select
                        outlined dense
                        v-model="Client.IsResident"
                        :items="Residency"
                        item-text="title"
                        item-value="value"
                        placeholder="----"
                        :rules="ResidencyRules"
                        label="Residency"
                      ></v-select>
                    </v-col>
                    <v-col class="pb-0 pt-0">
                      <v-select
                        outlined dense
                        v-model="Client.IsTaxable"
                        :items="Taxable"
                        item-text="title"
                        item-value="value"
                        placeholder="----"
                        label="Taxable?"
                      ></v-select>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col class="pb-0 pt-0">
                  <v-row>
                    <v-col class="pb-0 pt-0">
                      <v-select
                        outlined dense
                        v-model="Client.StatementFrequencyID"
                        :items="allFrequencies.filter(a => a.CheckerID != 0 && a.RejectionID == 0)"
                        item-text="Frequency"
                        item-value="FrequencyID"
                        placeholder="----"
                        :rules="TextFieldRules"
                        label="Statement Frequency"
                      ></v-select>
                    </v-col>
                    <v-col class="pb-0 pt-0">
                      <v-select
                        outlined dense
                        v-model="Client.DeliveryMethodID"
                        :items="allDeliveryMethods.filter(a => a.CheckerID != 0 && a.RejectionID == 0)"
                        item-text="DeliveryMethod"
                        item-value="DeliveryMethodID"
                        placeholder="----"
                        :rules="TextFieldRules"
                        label="Delivery Method"
                      ></v-select>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <span class="d-flex flex-row my-4">
                <v-spacer/>
                <v-btn @click="e1 = 3" outlined color="#2A353D" x-small fab><v-icon>mdi-chevron-left</v-icon></v-btn>
                <v-btn class="mx-2" @click="validateStep_4()" outlined color="#2A353D" x-small fab><v-icon>mdi-chevron-right</v-icon></v-btn>
                <v-btn class="white--text" small color="#2A353D" @click="closeCreate()">close</v-btn>
              </span>
            </v-form>
          </v-stepper-content>

          <v-stepper-content step="5">
            <v-form ref="step_5" v-model="step5_valid" lazy-validation elevation="12">
              <v-row class="ml-1 mr-1">
                <v-col class="pb-0">
                  <v-select
                    outlined dense
                    v-model="Client.SectorID"
                    :items="allSectors.filter(a => a.CheckerID != 0 && a.RejectionID == 0)"
                    item-text="SectorName"
                    item-value="SectorID"
                    placeholder="----"
                    :disabled="Client.Classification == 'Individual'? true : false"
                    :rules="Client.Classification == 'Individual'? '' : TextFieldRules"
                    label="Sector"
                  ></v-select>
                  <!-- <v-select
                    outlined dense
                    v-model="Client.FldInt01"
                    :items="Months"
                    item-text="name"
                    item-value="MonthID"
                    placeholder="----"
                    label="Year End"
                  ></v-select> -->

                  <!-- <v-text-field
                    :value="currentSystemDate.DayDate"
                    label="Date Opened"
                    append-icon="mdi-calendar-month"
                    readonly placeholder="--/--/--"
                    dense outlined color="#2A353D"
                    :rules="TextFieldRules"
                  ></v-text-field> -->

                  <v-menu
                    ref="menu_2"
                    v-model="menu_2"
                    :close-on-content-click="false"
                    :return-value.sync="Client.DateOpened"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="Client.DateOpened"
                      label="Date Opened"
                      append-icon="mdi-calendar-month"
                      readonly placeholder="--/--/--"
                      dense outlined color="#2A353D"
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                    </template>
                    <v-date-picker color="#2A353D" v-model="Client.DateOpened" no-title scrollable>
                    <v-spacer></v-spacer>
                    <v-btn outlined small color="#2A353D" @click="menu_2 = false">Cancel</v-btn>
                    <v-btn outlined small color="#2A353D" @click="$refs.menu_2.save(Client.DateOpened)">OK</v-btn>
                    </v-date-picker>
                  </v-menu>

                  <span class="my-0 py-0 caption font-weight-normal">None Trading Counters</span>
                  <v-select
                    outlined dense
                    hide-details
                    v-model="Exceptions"
                    :items="Counters"
                    item-text="EquityCode"
                    item-value="EquityID"
                    :readonly="view" chips
                    placeholder="----" multiple
                  ></v-select>
                </v-col>
                <v-col class="py-0">
                  <v-overlay absolute color="white"/>
                  <v-data-table
                    :headers="notification_headers"
                    :fixed-header="true"
                    :items="Notifications"
                    hide-default-footer
                    class="elevation-0 mt-2"
                  >
                  <template v-slot:item.IsMail="{ item }">
                    <v-simple-checkbox
                      v-model="item.IsMail"
                    ></v-simple-checkbox>
                  </template>
                  <template v-slot:item.IsSMS="{ item }">
                    <v-simple-checkbox
                      v-model="item.IsSMS"
                    ></v-simple-checkbox>
                  </template>
                  </v-data-table>
                </v-col>
              </v-row>
              <v-checkbox
                disabled
                class="mt-0"
                label="Block part of Investment as Security"
              ></v-checkbox>
              <v-row>
                <v-col class="py-0">
                  <v-text-field
                    light dense outlined
                    color="#2A353D"
                    label="Current Value"
                    disabled
                    placeholder="----"
                  ></v-text-field>
                </v-col>
                <v-col class="py-0">
                  <v-text-field
                    light dense outlined
                    color="#2A353D"
                    label="Value blocked"
                    disabled
                    placeholder="----"
                  ></v-text-field>
                </v-col>
                <v-col class="py-0">
                  <v-text-field
                    light dense outlined
                    color="#2A353D"
                    label="Net Value"
                    disabled
                    placeholder="----"
                  ></v-text-field>
                </v-col>
              </v-row>
              <span class="d-flex flex-row my-4">
                <v-spacer/>
                <v-btn @click="e1 = 4" outlined color="#2A353D" x-small fab><v-icon>mdi-chevron-left</v-icon></v-btn>
                <v-btn class="mx-2" disabled outlined color="#2A353D" x-small fab><v-icon>mdi-chevron-right</v-icon></v-btn>
                <v-btn class="white--text" small color="#2A353D" @click="closeCreate()">close</v-btn>
                <v-btn class="white--text ml-4" small color="#2A353D" :disabled="!valid" @click="createNew()">
                  <span v-show="loading" class="spinner-border spinner-border-sm mr-1"></span>
                  submit
                </v-btn>
              </span>
            </v-form>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </v-form>

<!-- ********************************************************************************************EDIT**************************************************************************************************
***************************************************************************************************************************************************************************************************** -->

    <v-form flat color="#ffffff00" v-if="edit">

      <span class="d-flex flex-row my-2">
        <span class="mr-2 grey--text caption font-weight-normal">Name: <span class="subtitle-2">{{currentClient.Classification == 'Individual' ? currentClient.Forename.toUpperCase() + " " + currentClient.MajorName.toUpperCase() : currentClient.MajorName.toUpperCase()}}</span></span>
        <v-spacer/>
        <span class="mr-2 grey--text caption font-weight-normal">Maker: <span class="subtitle-2">{{allUsers.filter(u => u.SecurityUserID == currentClient.MakerID).map(u => u.FullName)[0].toUpperCase()}}</span></span>
        <span v-if="currentClient.CheckerID != 0" class="mx-2 grey--text caption font-weight-normal">Checker: <span class="subtitle-2">{{allUsers.filter(u => u.SecurityUserID == currentClient.CheckerID).map(u => u.FullName)[0].toUpperCase()}}</span></span>
        <span class="ml-2 grey--text caption font-weight-normal">Last User: <span class="subtitle-2">{{allUsers.filter(u => u.SecurityUserID == currentClient.LastUserID).map(u => u.FullName)[0].toUpperCase()}}</span></span>
      </span>

      <v-stepper v-model="e1">
        <v-stepper-header class="elevation-0">
          <v-stepper-step
            :rules="[() => step1_valid]"
            :complete="e1 > 1"
            step="1"
          >
            Client Details
          </v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step
            :rules="[() => step2_valid]"
            :complete="e1 > 2"
            step="2"
          >
            Contact Details
          </v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step
            :rules="[() => step3_valid]"
            :complete="e1 > 3"
            step="3"
          >
            Bank Details
          </v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step
            :rules="[() => step4_valid]"
            :complete="e1 > 4"
            step="4"
          >
            Management
          </v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step
            :rules="[() => step5_valid]"
            :complete="e1 > 5"
            step="5"
          >
            Additional
          </v-stepper-step>
        </v-stepper-header>

        <v-stepper-items>
          <v-stepper-content step="1">
            <v-form ref="step_1" v-model="step1_valid" lazy-validation elevation="12">
              <v-row class="ml-1 mr-1">
                <v-col class="pb-0">
                  <v-select
                    outlined dense
                    v-model="currentClient.Classification"
                    :items="Classifications"
                    item-text="class"
                    item-value="class"
                    placeholder="----"
                    :readonly="view"
                    :rules="TextFieldRules"
                    label="Client Classification"
                  ></v-select>
                  <v-text-field
                    light dense outlined
                    color="#2A353D"
                    v-model="currentClient.MajorName"
                    :label="currentClient.Classification == 'Individual' ? 'Surname' : currentClient.Classification == 'Corporate' ? 'Corporate Name' : 'Institution Name'"
                    required
                    :readonly="view"
                    :rules="[
                      v => !!v || 'field is required',
                      v => (v && v.length <= 150) || 'field must be less than 150 characters'
                    ]"
                    placeholder="----"
                  ></v-text-field>
                  <v-text-field
                    light dense outlined
                    color="#2A353D"
                    v-model="currentClient.Forename"
                    :label="currentClient.Classification == 'Individual' ? 'Forename' : 'Trade Name'"
                    required
                    :readonly="view"
                    :rules="[
                      v => v ? (v && v.length <= 50) || 'field must be less than 50 characters' : null
                    ]"
                    placeholder="----"
                  ></v-text-field>
                  <v-text-field
                    light dense outlined
                    color="#2A353D"
                    v-model="currentClient.IDNumber"
                    :label="currentClient.Classification == 'Individual' ? 'ID Number' : 'Registration/Identification Number'"
                    required
                    :readonly="view"
                    :rules="[
                      v => !!v || 'field is required',
                      v => (v && v.length <= 50) || 'field must be less than 50 characters'
                    ]"
                    placeholder="----"
                  ></v-text-field>
                  <v-text-field
                    light dense outlined
                    color="#2A353D"
                    v-model="currentClient.ExternalRef"
                    label="CSD Number"
                    required
                    :readonly="view"
                    placeholder="----"
                  ></v-text-field>
                </v-col>

                <v-col :class="currentClient.Classification == 'Individual'? 'pb-0':'pb-0 mt-12 pt-7'">
                  <v-text-field
                    light dense outlined
                    color="#2A353D"
                    v-model="currentClient.ClientCode"
                    label="CIF Number"
                    disabled
                    placeholder="----"
                  ></v-text-field>
                  <v-select
                    v-if="currentClient.Classification == 'Individual'"
                    outlined dense
                    v-model="currentClient.Gender"
                    :items="Gender"
                    item-text="title"
                    item-value="title"
                    placeholder="----"
                    :readonly="view"
                    :rules="TextFieldRules"
                    label="Gender"
                  ></v-select>
                  <v-select
                    v-else
                    outlined dense
                    v-model="currentClient.ClientTypeID"
                    :items="currentClient.Classification == 'Corporate' ? allClientTypes.filter(a => CorporateCategories.includes(a.ClientTypeID) == true && a.CheckerID != 0 && a.RejectionID == 0) : allClientTypes.filter(a => InstitutionCategories.includes(a.ClientTypeID) == true && a.CheckerID != 0 && a.RejectionID == 0)"
                    item-text="ClientType"
                    item-value="ClientTypeID"
                    placeholder="----"
                    :readonly="view"
                    :rules="TextFieldRules"
                    label="Client Category"
                  ></v-select>
                  <v-select
                    v-if="currentClient.Classification == 'Individual'"
                    outlined dense
                    v-model="currentClient.TitleID"
                    :items="allTitles.filter(a => a.CheckerID != 0 && a.RejectionID == 0)"
                    item-text="Title"
                    item-value="TitleID"
                    placeholder="----"
                    :readonly="view"
                    :rules="TextFieldRules"
                    label="Title"
                  ></v-select>
                  <v-select
                    outlined dense
                    v-model="currentClient.IdentityTypeID"
                    :items="currentClient.Classification == 'Individual'? allIdentityTypes.filter(a => a.CategoryID == 6 && a.CheckerID != 0 && a.RejectionID == 0) : IdentityTypes.filter(a => (a.CategoryID == currentClient.ClientTypeID || a.CategoryID == 0) && a.CheckerID != 0 && a.RejectionID == 0)"
                    item-text="IdentityType"
                    item-value="IdentityTypeID"
                    placeholder="----"
                    :readonly="view"
                    label="Identity type"
                  ></v-select>
                  <v-menu
                    ref="menu"
                    v-model="menu"
                    :close-on-content-click="false"
                    :return-value.sync="currentClient.DateOfBirth"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="currentClient.DateOfBirth"
                        :label="currentClient.Classification == 'Individual'? 'Date of Birth':'Registered Date'"
                        append-icon="mdi-calendar-month"
                        readonly placeholder="--/--/--"
                        :disabled="view"
                        dense outlined color="#2A353D"
                        :rules="TextFieldRules"
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker color="#2A353D" v-model="currentClient.DateOfBirth" no-title scrollable>
                    <v-spacer></v-spacer>
                    <v-btn outlined small color="#2A353D" @click="menu = false">Cancel</v-btn>
                    <v-btn outlined small color="#2A353D" @click="$refs.menu.save(currentClient.DateOfBirth)">OK</v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
              <span class="d-flex flex-row my-4">
                <v-spacer/>
                <v-btn disabled outlined color="#2A353D" x-small fab><v-icon>mdi-chevron-left</v-icon></v-btn>
                <v-btn class="mx-2" @click="validateStep_1()" outlined color="#2A353D" x-small fab><v-icon>mdi-chevron-right</v-icon></v-btn>
                <v-btn class="white--text" small color="#2A353D" @click="view = false; closeEdit()">close</v-btn>
              </span>
            </v-form>
          </v-stepper-content>

          <v-stepper-content step="2">
            <v-form ref="step_2" v-model="step2_valid" lazy-validation flat>
              <v-row class="ml-1 mr-1">
                <v-col class="pb-0">
                  <v-card class="pa-5 pt-2">
                    <span class="caption">Physical Address</span>
                    <v-text-field
                      light dense
                      color="#2A353D"
                      v-model="currentClient.Physical_Address_1"
                      required
                      :readonly="view"
                      :rules="TextFieldRules"
                    ></v-text-field>
                    <v-text-field
                      light dense
                      color="#2A353D"
                      v-model="currentClient.Physical_Address_2"
                      required
                      :readonly="view"
                    ></v-text-field>
                    <v-text-field
                      light dense
                      color="#2A353D"
                      v-model="currentClient.Physical_Address_3"
                      required
                      :readonly="view"
                    ></v-text-field>
                    <v-select
                      filled dense
                      v-model="currentClient.Physical_CountryId"
                      :items="allCountries.filter(a => a.CheckerID != 0 && a.RejectionID == 0)"
                      item-text="CountryName"
                      item-value="CountryId"
                      label="Country"
                      :readonly="view"
                      :rules="TextFieldRules"
                    ></v-select>
                    <v-select
                      filled dense
                      v-model="currentClient.Physical_CityID"
                      :items="allCities.filter(a => a.CountryId == currentClient.Physical_CountryId && a.CheckerID != 0 && a.RejectionID == 0)"
                      item-text="City"
                      item-value="CityID"
                      label="City"
                      :readonly="view"
                      :rules="TextFieldRules"
                    ></v-select>
                  </v-card>
                </v-col>
                <v-col class="pb-0">
                  <v-card v-if="SyncAddress == false" class="pa-5 pt-2">
                    <span class="caption">Postal Address</span>
                    <v-text-field
                      light dense
                      color="#2A353D"
                      v-model="currentClient.Postal_Address_1"
                      required
                      :readonly="view"
                      :rules="TextFieldRules"
                    ></v-text-field>
                    <v-text-field
                      light dense
                      color="#2A353D"
                      v-model="currentClient.Postal_Address_2"
                      required
                      :readonly="view"
                    ></v-text-field>
                    <v-text-field
                      light dense
                      color="#2A353D"
                      v-model="currentClient.Postal_Address_3"
                      required
                      :readonly="view"
                    ></v-text-field>
                    <v-select
                      filled dense
                      v-model="currentClient.Postal_CountryId"
                      :items="allCountries.filter(a => a.CheckerID != 0 && a.RejectionID == 0)"
                      item-text="CountryName"
                      item-value="CountryId"
                      label="Country"
                      :readonly="view"
                      :rules="TextFieldRules"
                    ></v-select>
                    <v-select
                      filled dense
                      v-model="currentClient.Postal_CityID"
                      :items="allCities.filter(a => a.CountryId == currentClient.Postal_CountryId && a.CheckerID != 0 && a.RejectionID == 0)"
                      item-text="City"
                      item-value="CityID"
                      label="City"
                      :readonly="view"
                      :rules="TextFieldRules"
                    ></v-select>
                  </v-card>

                  <v-card v-else class="pa-5 pt-2">
                    <span class="caption">Postal Address</span>
                    <v-text-field
                      light dense
                      color="#2A353D"
                      v-model="currentClient.Physical_Address_1"
                      required
                      :readonly="view"
                      :rules="TextFieldRules"
                    ></v-text-field>
                    <v-text-field
                      light dense
                      color="#2A353D"
                      v-model="currentClient.Physical_Address_2"
                      required
                      :readonly="view"
                    ></v-text-field>
                    <v-text-field
                      light dense
                      color="#2A353D"
                      v-model="currentClient.Physical_Address_3"
                      required
                      :readonly="view"
                    ></v-text-field>
                    <v-select
                      filled dense
                      v-model="currentClient.Physical_CountryId"
                      :items="allCountries.filter(a => a.CheckerID != 0 && a.RejectionID == 0)"
                      item-text="CountryName"
                      item-value="CountryId"
                      label="Country"
                      :readonly="view"
                      :rules="TextFieldRules"
                    ></v-select>
                    <v-select
                      filled dense
                      v-model="currentClient.Physical_CityID"
                      :items="allCities.filter(a => a.CountryId == currentClient.Physical_CountryId && a.CheckerID != 0 && a.RejectionID == 0)"
                      item-text="City"
                      item-value="CityID"
                      label="City"
                      :readonly="view"
                      :rules="TextFieldRules"
                    ></v-select>
                  </v-card>
                </v-col>
                <v-col class="pb-0">
                  <v-text-field
                    light dense outlined
                    color="#2A353D"
                    v-model="currentClient.Email"
                    label="Email"
                    :readonly="view"
                    :rules="currentClient.Email == null ? '' : emailRules"
                    placeholder="----"
                  ></v-text-field>
                  <v-text-field
                    light dense outlined
                    color="#2A353D"
                    v-model="currentClient.MobileNumber"
                    label="Mobile Number"
                    required
                    type="number"
                    :readonly="view"
                    :rules="currentClient.MobileNumber == null ? '' : MobileRules"
                    placeholder="----"
                  ></v-text-field>
                  <v-text-field
                    light dense outlined
                    color="#2A353D"
                    v-model="currentClient.Telephone1"
                    label="Telephone #1"
                    :readonly="view"
                    placeholder="----"
                  ></v-text-field>
                  <v-text-field
                    light dense outlined
                    color="#2A353D"
                    v-model="currentClient.Telephone2"
                    label="Telephone #2"
                    :readonly="view"
                    placeholder="----"
                  ></v-text-field>
                  <v-select
                    light dense outlined
                    v-model="currentClient.Nationality"
                    :items="allCountries.filter(a => a.CheckerID != 0 && a.RejectionID == 0)"
                    item-text="Nationality"
                    item-value="CountryId"
                    label="Nationality"
                    placeholder="----"
                    :readonly="view"
                    :rules="TextFieldRules"
                  ></v-select>
                </v-col>
              </v-row>
              <v-row class="ml-1 mr-1">
                <v-col cols="8">
                  <div class="text-center">
                    <v-btn @click="syncPostalAddress()" block outlined rounded color="#2A353D" class="pr-3" v-on="on">
                      Make Postal address the same as the Physical address<v-icon class="ml-1">mdi-cached</v-icon>
                    </v-btn>
                  </div>
                </v-col>
              </v-row>

              <v-divider/>

              <span class="d-flex flex-row my-4">
                <v-spacer/>
                <v-btn @click="e1 = 1" outlined color="#2A353D" x-small fab><v-icon>mdi-chevron-left</v-icon></v-btn>
                <v-btn class="mx-2" @click="validateStep_2()" outlined color="#2A353D" x-small fab><v-icon>mdi-chevron-right</v-icon></v-btn>
                <v-btn class="white--text" small color="#2A353D" @click="view = false; closeEdit()">close</v-btn>
              </span>
            </v-form>
          </v-stepper-content>

          <v-stepper-content step="3">
            <v-form ref="step_3" v-model="step3_valid" lazy-validation flat>
              <v-row class="ml-1 mr-1">
                <v-col class="pb-0">
                  <v-select
                    outlined dense
                    v-model="currentClient.BankID"
                    :items="allBanks.filter(a => a.CheckerID != 0 && a.RejectionID == 0)"
                    item-text="Bank"
                    item-value="BankID"
                    placeholder="----"
                    :readonly="view"
                    :rules="TextFieldRules"
                    label="Bank"
                  ></v-select>
                  <v-text-field
                    light dense outlined
                    color="#2A353D"
                    v-model="currentClient.BankAccNumber"
                    label="Account Number"
                    required
                    :readonly="view"
                    :rules="[
                      v => !!v || 'field is required',
                      v => (v && v.length <= 40) || 'field must be less than 40 characters'
                    ]"
                    placeholder="----"
                  ></v-text-field>
                  <v-select
                    outlined dense
                    v-model="currentClient.BankAccountTypeID"
                    :items="allBankAccountTypes.filter(a => a.CheckerID != 0 && a.RejectionID == 0)"
                    item-text="BankAccountType"
                    item-value="BankAccountTypeID"
                    placeholder="----"
                    :readonly="view"
                    :rules="TextFieldRules"
                    label="Account Type"
                  ></v-select>
                </v-col>
                <v-col class="pb-0">
                  <v-select
                    outlined dense
                    v-model="currentClient.BranchID"
                    :items="allBankBranches.filter(a => a.BankID == currentClient.BankID && a.CheckerID != 0 && a.RejectionID == 0)"
                    item-text="BranchName"
                    item-value="BranchID"
                    placeholder="----"
                    :readonly="view"
                    :rules="TextFieldRules"
                    label="Branch"
                  ></v-select>
                  <v-text-field
                    light dense outlined
                    color="#2A353D"
                    v-model="currentClient.BankAccName"
                    label="Account Name"
                    required
                    :readonly="view"
                    :rules="[
                      v => !!v || 'field is required',
                      v => (v && v.length <= 50) || 'field must be less than 50 characters'
                    ]"
                    placeholder="----"
                  ></v-text-field>
                </v-col>
              </v-row>
              <span class="d-flex flex-row my-4">
                <v-spacer/>
                <v-btn @click="e1 = 2" outlined color="#2A353D" x-small fab><v-icon>mdi-chevron-left</v-icon></v-btn>
                <v-btn class="mx-2" @click="validateStep_3()" outlined color="#2A353D" x-small fab><v-icon>mdi-chevron-right</v-icon></v-btn>
                <v-btn class="white--text" small color="#2A353D" @click="view = false; closeEdit()">close</v-btn>
              </span>
            </v-form>
          </v-stepper-content>

          <v-stepper-content step="4">
            <v-form ref="step_4" v-model="step4_valid" lazy-validation flat>
              <v-row class="ml-1 mr-1">
                <v-col class="pb-0">
                  <v-textarea
                    class="mb-0"
                    label="Standing Instructions"
                    v-model="currentClient.StandingInstructions"
                    outlined
                    rows="6"
                    :readonly="view"
                    placeholder="No standing instruction"
                    row-height="15"
                  ></v-textarea>
                </v-col>
                <v-col class="pb-0">
                  <v-select
                    outlined dense
                    v-model="currentClient.CustodianID"
                    :items="allCustodians.filter(a => a.ProfileType != 3 && a.CheckerID != 0 && a.RejectionID == 0)"
                    item-text="CustodianName"
                    item-value="CustodianID"
                    placeholder="----"
                    :readonly="view"
                    :rules="TextFieldRules"
                    label="Custodianship/Trading Acc"
                  ></v-select>
                  <v-select
                    outlined dense
                    v-model="currentClient.ClientGroupId"
                    :items="allCustodians.filter(a => a.ProfileType == 3 && a.CheckerID != 0 && a.RejectionID == 0)"
                    item-text="CustodianName"
                    item-value="CustodianID"
                    placeholder="----"
                    :readonly="view"
                    label="Client Group"
                  ></v-select>
                  <v-select
                    outlined dense
                    v-model="currentClient.ConsultantID"
                    :items="Consultants"
                    item-text="CustodianName"
                    item-value="CustodianID"
                    placeholder="----"
                    :readonly="view"
                    label="Administrator"
                  ></v-select>
                </v-col>
              </v-row>
              <v-row class="ml-1 mr-1">
                <v-col class="pb-0 pt-0">
                  <v-row>
                    <v-col class="pb-0 pt-0">
                      <v-select
                        outlined dense
                        v-model="currentClient.IsResident"
                        :items="Residency"
                        item-text="title"
                        item-value="value"
                        placeholder="----"
                        :rules="ResidencyRules"
                        :readonly="view"
                        label="Residency"
                      ></v-select>
                    </v-col>
                    <v-col class="pb-0 pt-0">
                      <v-select
                        outlined dense
                        v-model="currentClient.IsTaxable"
                        :items="Taxable"
                        item-text="title"
                        item-value="value"
                        placeholder="----"
                        :readonly="view"
                        label="Taxable?"
                      ></v-select>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col class="pb-0 pt-0">
                  <v-row>
                    <v-col class="pb-0 pt-0">
                      <v-select
                        outlined dense
                        v-model="currentClient.StatementFrequencyID"
                        :items="allFrequencies.filter(a => a.CheckerID != 0 && a.RejectionID == 0)"
                        item-text="Frequency"
                        item-value="FrequencyID"
                        placeholder="----"
                        :readonly="view"
                        :rules="TextFieldRules"
                        label="Statement Frequency"
                      ></v-select>
                    </v-col>
                    <v-col class="pb-0 pt-0">
                      <v-select
                        outlined dense
                        v-model="currentClient.DeliveryMethodID"
                        :items="allDeliveryMethods.filter(a => a.CheckerID != 0 && a.RejectionID == 0)"
                        item-text="DeliveryMethod"
                        item-value="DeliveryMethodID"
                        placeholder="----"
                        :readonly="view"
                        :rules="TextFieldRules"
                        label="Delivery Method"
                      ></v-select>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <span class="d-flex flex-row my-4">
                <v-spacer/>
                <v-btn @click="e1 = 3" outlined color="#2A353D" x-small fab><v-icon>mdi-chevron-left</v-icon></v-btn>
                <v-btn class="mx-2" @click="validateStep_4()" outlined color="#2A353D" x-small fab><v-icon>mdi-chevron-right</v-icon></v-btn>
                <v-btn class="white--text" small color="#2A353D" @click="view = false; closeEdit()">close</v-btn>
              </span>
            </v-form>
          </v-stepper-content>

          <v-stepper-content step="5">
            <v-form ref="step_5" v-model="step5_valid" lazy-validation flat>
              <v-row class="ml-1 mr-1">
                <v-col class="pb-0">
                  <v-select
                    outlined dense
                    v-model="currentClient.SectorID"
                    :items="allSectors.filter(a => a.CheckerID != 0 && a.RejectionID == 0)"
                    item-text="SectorName"
                    item-value="SectorID"
                    placeholder="----"
                    :readonly="view"
                    :disabled="currentClient.Classification == 'Individual'? true : false"
                    :rules="currentClient.Classification == 'Individual'? '' : TextFieldRules"
                    label="Sector"
                  ></v-select>
                  <!-- <v-select
                    outlined dense
                    v-model="currentClient.FldInt01"
                    :items="Months"
                    item-text="name"
                    item-value="MonthID"
                    placeholder="----"
                    label="Year End"
                    :readonly="view"
                  ></v-select> -->
                  <v-menu
                    ref="menu_2"
                    v-model="menu_2"
                    :close-on-content-click="false"
                    :return-value.sync="currentClient.DateOpened"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="currentClient.DateOpened"
                      label="Date Opened"
                      append-icon="mdi-calendar-month"
                      :readonly="view" placeholder="--/--/--"
                      dense outlined color="#2A353D"
                      :rules="TextFieldRules"
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                    </template>
                    <v-date-picker color="#2A353D" v-model="currentClient.DateOpened" no-title scrollable>
                    <v-spacer></v-spacer>
                    <v-btn outlined small color="#2A353D" @click="menu_2 = false">Cancel</v-btn>
                    <v-btn outlined small color="#2A353D" @click="$refs.menu_2.save(currentClient.DateOpened)">OK</v-btn>
                    </v-date-picker>
                  </v-menu>
                  <!-- <v-menu
                    ref="menu"
                    v-model="menu"
                    :close-on-content-click="false"
                    :return-value.sync="Client.DateClosed"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="Client.DateClosed"
                      label="Date Closed"
                      append-icon="mdi-calendar-month"
                      readonly placeholder="--/--/--"
                      dense outlined color="#2A353D"
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                    </template>
                    <v-date-picker color="#2A353D" v-model="Client.DateClosed" no-title scrollable>
                    <v-spacer></v-spacer>
                    <v-btn outlined small color="#2A353D" @click="menu = false">Cancel</v-btn>
                    <v-btn outlined small color="#2A353D" @click="$refs.menu.save(Client.DateClosed)">OK</v-btn>
                    </v-date-picker>
                  </v-menu> -->

                  <span class="my-0 py-0 caption font-weight-normal">None Trading Counters</span>
                  <v-select
                    outlined dense
                    hide-details
                    v-model="currentExceptions"
                    :items="Counters"
                    item-text="EquityCode"
                    item-value="EquityID"
                    :readonly="view" chips
                    placeholder="----" multiple
                  ></v-select>
                </v-col>
                <v-col class="py-0">
                  <v-overlay absolute color="white"/>
                  <v-data-table
                    :headers="notification_headers"
                    :fixed-header="true"
                    :items="Notifications"
                    hide-default-footer
                    class="elevation-0 mt-2"
                  >
                  <template v-slot:item.IsMail="{ item }">
                    <v-simple-checkbox
                      v-model="item.IsMail"
                      :readonly="view"
                    ></v-simple-checkbox>
                  </template>
                  <template v-slot:item.IsSMS="{ item }">
                    <v-simple-checkbox
                      v-model="item.IsSMS"
                      :readonly="view"
                    ></v-simple-checkbox>
                  </template>
                  </v-data-table>
                </v-col>
              </v-row>
              <v-checkbox
                :disabled="allClientAccounts.filter(a => a.ClientID == currentClient.ClientID).length > 0? false : true"
                v-model="currentClient.BlockFlag"
                class="mt-0"
                label="Block part of Investment as Security"
                :readonly="view"
              ></v-checkbox>
              <v-row>
                <v-col class="py-0">
                  <v-text-field
                    light dense outlined
                    color="#2A353D"
                    :value="Number(currentValue).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2})"
                    label="Current Value"
                    :disabled="currentClient.BlockFlag == true? false : true"
                    required
                    readonly
                    placeholder="----"
                  ></v-text-field>
                </v-col>
                <v-col class="py-0">
                  <v-text-field
                    light dense outlined
                    color="#2A353D"
                    v-model="currentClient.BlockedValue"
                    label="Value blocked"
                    required
                    :readonly="view"
                    :disabled="currentClient.BlockFlag == true? false : true"
                    type="number"
                    :rules="currentClient.BlockFlag == true ? TextFieldRules : ''"
                    placeholder="----"
                  ></v-text-field>
                </v-col>
                <v-col class="py-0">
                  <v-text-field
                    light dense outlined
                    color="#2A353D"
                    :value="(currentValue - currentClient.BlockedValue).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2})"
                    label="Net Value"
                    required
                    :disabled="currentClient.BlockFlag == true? false : true"
                    :readonly="view"
                    :rules="[
                      v =>  v >= '0' || 'Current Value has been exceeded',
                    ]"
                    placeholder="----"
                  ></v-text-field>
                </v-col>
              </v-row>
              <span class="d-flex flex-row my-4">
                <v-spacer/>
                <v-btn @click="e1 = 4" outlined color="#2A353D" x-small fab><v-icon>mdi-chevron-left</v-icon></v-btn>
                <v-btn class="mx-2" disabled outlined color="#2A353D" x-small fab><v-icon>mdi-chevron-right</v-icon></v-btn>
                <v-btn class="white--text" small color="#2A353D" @click="view = false; closeEdit()">close</v-btn>
                <v-btn class="white--text ml-4" v-if="!view" small color="#2A353D" :disabled="!valid" @click="update()">
                  <span v-show="loading" class="spinner-border spinner-border-sm mr-1"></span>
                  save
                </v-btn>
              </span>
            </v-form>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </v-form>

    <v-data-table
      disable-pagination
      hide-default-footer
      :height="520"
      :headers="headers"
      :fixed-header="true"
      :items="confirmedClients ? allClients : allClients.filter(a => a.CheckerID === 0)"
      :search="search" v-if="!create &&  !edit"
      sort-by="MakeDate"
      sort-desc
      class="elevation-12 mt-2"
      @current-items="getFiltered"
    >

      <template v-slot:top >
        <v-dialog persistent v-model="rejectionDialog" max-width="500px">
          <v-card>
            <v-card-title>
              <span class="subtitle-1 grey--text">Choose a reason for this rejection</span>
            </v-card-title>

            <v-card-text>
              <v-select
                filled dense
                v-model="RejectionStatus"
                :items="allRejectionReasons.filter(a => a.CheckerID != 0 && a.RejectionID == 0)"
                item-text="RejectionReasonDescription"
                item-value="RejectionReasonID"
                label="Rejection Reasons"
              ></v-select>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <div class="text-right mb-4">
                <v-btn class="white--text mr-3" small color="#2A353D" @click="RejectionStatus = 0; rejectionDialog = false">cancel</v-btn>
                <v-btn class="white--text mr-3" small color="#2A353D" v-if="RejectionStatus !== 0" @click="updateStatus()">
                  <span v-show="loading" class="spinner-border spinner-border-sm mr-1"></span>
                  ok
                </v-btn>
              </div>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog persistent v-model="deleteDialog" max-width="350px">
          <v-card>
            <v-card-title>
              <span class="subtitle-1 grey--text text-center ma-4 mx-7">Are you sure you want to DELETE  the selected item?</span>
            </v-card-title>

            <v-card-actions>
              <v-spacer></v-spacer>
              <div class="text-right mb-4">
                <v-btn class="white--text mr-3" small color="#2A353D" @click="deleteDialog = false">no</v-btn>
                <v-btn class="white--text mr-3" small color="#2A353D" @click="deleteItem()">
                  <span v-show="loading" class="spinner-border spinner-border-sm mr-1"></span>
                  yes
                </v-btn>
              </div>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-container row>
          <v-text-field
            class="ml-3"
            hide-details
            outlined
            placeholder="search..."
            v-model="search"
            append-icon="mdi-magnify"
            dense
          ></v-text-field>

          <v-spacer></v-spacer>

          <v-btn v-if="showCreateBtn == true" v-show="confirmedClients" @click="showCreate(); closeEdit()" outlined small color="#2A353D" class="ml-2">
            Create New<v-icon small>mdi-plus</v-icon>
          </v-btn>
          <v-menu open-on-hover offset-y>
            <template v-slot:activator="{ on, attrs }">
            <v-btn v-on="on" v-bind="attrs" v-show="confirmedClients" outlined small color="#2A353D" class="ml-2">
              EXPORT<v-icon class="ml-1" small>mdi-exit-to-app</v-icon>
            </v-btn>
            </template>
            <v-list dense>
            <v-list-item class="ma-0 pa-0">
              <v-btn @click="generatePDF(false)" text small color="#2A353D">
                <v-icon class="mr-1" small>mdi-file-pdf-box</v-icon>TO PDF
              </v-btn>
            </v-list-item>
            <v-list-item class="ma-0 pa-0">
              <v-btn text small color="#2A353D">
                <download-excel
                  :data   = "CurrentDataset"
                  type    = "xls"
                  name    = "Clients.xls">
    
                  <v-icon class="mr-1" small>mdi-microsoft-excel</v-icon>TO EXCEL
                </download-excel>
              </v-btn>
            </v-list-item>
            <v-list-item class="ma-0 pa-0">
              <v-btn text small color="#2A353D">
                <download-excel
                  :data   = "CurrentDataset"
                  type    = "csv"
                  name    = "Clients.csv">
    
                  <v-icon class="mr-1" small>mdi-file-document-outline</v-icon>TO CSV
                </download-excel>
              </v-btn>
            </v-list-item>
            </v-list>
          </v-menu>
          <v-btn @click="generatePDF(true)" v-show="confirmedClients" outlined small color="#2A353D" class="ml-2" v-on="on">
            PRINT<v-icon class="ml-1" small>mdi-printer</v-icon>
          </v-btn>
          <v-btn v-show="!confirmedClients" @click="confirmedClients = true" outlined small color="#2A353D" class="ml-2" v-on="on">
            ALL RECORDS<v-icon class="ml-1">mdi-playlist-check</v-icon>
          </v-btn>
        </v-container>

        <v-dialog v-model="signatories_dialog" persistent max-width="1050px">
          <ClientSignatories :currentClient="currentClient" :confirmedSignatories="pending"/>
        </v-dialog>

        <v-dialog v-model="contacts_dialog" persistent max-width="1000px">
          <ClientContacts :currentClient="currentClient" :confirmedContacts="pending"/>
        </v-dialog>

        <v-dialog v-model="accounts_dialog" persistent max-width="1000px">
          <ClientAccounts :currentClient="currentClient" :confirmedAccounts="pending"/>
        </v-dialog>

        <v-dialog v-model="kyc_dialog" persistent max-width="1000px">
          <ClientKYCDocuments :currentClient="currentClient"/>
        </v-dialog>

      </template>

      <template v-slot:item.actions="{ item }">

        <v-tooltip v-if="!confirmedClients && item.CheckerID == 0" top>
          <template v-slot:activator="{ on }">
          <v-btn
            small @click="setActiveClient(item, index); updateStatus()"
            outlined :disabled="showConfirmBtn == false || item.MakerID == currentUser.SecurityUserID || item.LastUserID == currentUser.SecurityUserID"
            v-on="on"
            color="#2A353D" class="mr-3"
          >
            <span v-show="loading" class="spinner-border spinner-border-sm mr-1"></span>
            confirm<v-icon class="ml-1" color="#2A353D">mdi-check-circle-outline</v-icon>
          </v-btn>
          </template>
          <span>confirm</span>
        </v-tooltip>
        <v-tooltip v-if="!confirmedClients && item.CheckerID == 0" top>
          <template v-slot:activator="{ on }">
          <v-btn
            small @click="rejectionDialog = true; setActiveClient(item, index)"
            outlined :disabled="showConfirmBtn == false || item.MakerID == currentUser.SecurityUserID || item.LastUserID == currentUser.SecurityUserID"
            v-on="on"
            color="#2A353D" class="mr-3"
          >
            reject<v-icon class="ml-1" color="#2A353D">mdi-close-circle-outline</v-icon>
          </v-btn>
          </template>
          <span>reject</span>
        </v-tooltip>
        <v-btn
          v-show="confirmedClients"
          small outlined :disabled="edit" v-if="item.CheckerID == 0? item.MakerID == currentUser.SecurityUserID : showEditBtn == true"
          @click="setActiveClient(item, index); showEdit(); closeCreate()"
          color="#2A353D" class="mr-3"
        >
          <span>edit</span>
        </v-btn>
        <v-btn
          small outlined
          :disabled="edit"
          @click="view = true; setActiveClient(item, index); showEdit(); closeCreate()"
          color="#2A353D" class="mr-3"
        >
          <span>view</span>
        </v-btn>
        <v-menu v-if="confirmedClients" open-on-hover offset-y>
          <template v-slot:activator="{ on, attrs }">
          <v-btn class="mr-1" v-show="confirmedClients" v-on="on" v-bind="attrs" outlined small color="#2A353D">
            MORE<v-icon class="ml-1" small>mdi-chevron-down</v-icon>
          </v-btn>
          </template>
          <v-list dense>
          <v-list-item class="ma-0 pa-0">
            <v-btn @click="signatories_dialog = true; setActiveClient(item, index)" text small color="#2A353D">
              <v-icon left small>mdi-draw</v-icon>SIGNATORIES
            </v-btn>
          </v-list-item>
          <v-list-item class="ma-0 pa-0">
            <v-btn @click="contacts_dialog = true; setActiveClient(item, index)" text small color="#2A353D">
              <v-icon left small>mdi-contacts-outline</v-icon>CONTACT PERSONS
            </v-btn>
          </v-list-item>
          <v-list-item class="ma-0 pa-0">
            <v-btn @click="accounts_dialog = true; setActiveClient(item, index)" text small color="#2A353D">
              <v-icon left small>mdi-card-account-details-outline</v-icon>ACCOUNTS
            </v-btn>
          </v-list-item>
          <v-list-item class="ma-0 pa-0">
            <v-btn @click="kyc_dialog = true; setActiveClient(item, index)" text small color="#2A353D">
              <v-icon left small>mdi-file-document-outline</v-icon>KYC DOCUMENTS
            </v-btn>
          </v-list-item>
          </v-list>
        </v-menu>
        <v-icon
          :disabled="item.MakerID == currentUser.SecurityUserID && item.CheckerID == 0 ? false : true"
          color="#2A353D" @click="setActiveClient(item, index); deleteDialog = true"
        >
        mdi-trash-can-outline
        </v-icon>
      </template>

      <template v-slot:item.TitleID="{ item }">
        {{getTitle(item.TitleID)}}
      </template>

      <template v-slot:item.status="{ item }">
        <v-chip outlined small color="error" v-if="item.RejectionID !== 0">rejected</v-chip>
        <v-chip outlined small color="warning" v-if="item.CheckerID == 0">pending</v-chip>
        <v-chip outlined dark small color="#A6D879" v-if="item.CheckerID !== 0 && item.RejectionID == 0">confirmed</v-chip>
      </template>

      <!-- <template v-slot:item.AccountID="{ item }">
        {{getAccountName(item.AccountID)}}
      </template>

      <template v-slot:item.PurchaseDate="{ item }">
        {{ item.PurchaseDate | moment("DD MMM YYYY") }}
      </template> 

      <template v-slot:item.ValueDate="{ item }">
        {{ item.ValueDate | moment("DD MMM YYYY") }}
      </template> 

      <template v-slot:item.MakeDate="{ item }">
        {{ item.MakeDate | moment("DD MMMM YYYY") }}
      </template> -->

    </v-data-table>
  </v-container>
</template>

<script>
import {mapGetters, mapActions} from "vuex";
import ClientSignatories from './ClientSignatories';
import ClientContacts from './ClientContacts';
import ClientAccounts from './ClientAccounts';
import ClientKYCDocuments from './ClientsKYCDocuments'
import administrationService from '../services/administration.service';
import UserService from '../services/user.service';
import jsPDF from 'jspdf';
import 'jspdf-autotable'

export default {
  components: {
    ClientSignatories,
    ClientContacts,
    ClientAccounts,
    ClientKYCDocuments
  },

  data () {
    return {
      confirmedClients: true,
      pending: true,
      Individual: true,
      currentClient: {},
      CurrentDataset: [],
      rejectionDialog: false,
      deleteDialog: false,
      permitted: null,
      permitted_dialog: true,
      RejectionStatus: 0,
      signatories_dialog: false,
      contacts_dialog: false,
      accounts_dialog: false,
      kyc_dialog: false,
      create:false,
      edit: false,
      view: false,
      menu: false,
      menu_2: false,
      loading: false,
      message: '',
      search: '',
      e1: 1,
      Gender: [
        {title : 'M'},
        {title : 'F'}
      ],
      Classifications: [
        {class: 'Corporate'},
        {class: 'Institution'},
        {class: 'Individual'}
      ],
      CorporateCategories: [
        1,2,4,5
      ],
      InstitutionCategories: [
        3,17,18,19,20,21
      ],
      Months: [
        {name : 'January', MonthID : 1},
        {name : 'February', MonthID : 2},
        {name : 'March', MonthID : 3},
        {name : 'April', MonthID : 4},
        {name : 'May', MonthID : 5},
        {name : 'June', MonthID : 6},
        {name : 'July', MonthID : 7},
        {name : 'August', MonthID : 8},
        {name : 'September', MonthID : 9},
        {name : 'October', MonthID : 10},
        {name : 'November', MonthID : 11},
        {name : 'December', MonthID : 12},
      ],
      Notifications: [
        {Notification : 'New Client', IsMail : 0, IsSMS : 0},
        {Notification : 'Deal Transaction', IsMail : 0, IsSMS : 0},
        {Notification : 'Reporting', IsMail : 0, IsSMS : 0},
        {Notification : 'Anniversary', IsMail : 0, IsSMS : 0},
      ],
      Taxable: [
        {title : 'YES', value : 1},
        {title : 'NO', value : 0}
      ],
      Residency: [
        {title : 'Resident', value : 1},
        {title : 'Non-Resident', value : 0}
      ],
      headers: [
        { text: 'MajorName', align: 'start', value: 'MajorName', sortable: true },
        { text: 'Mobile Number', value: 'MobileNumber', sortable: true },
        { text: 'Email', value: 'Email', sortable: true },
        { text: 'Status', value: 'status', sortable: false },
        { value: 'actions', sortable: false, align: 'end' },
      ],
      notification_headers: [
        {
          text: 'Notifications',
          align: 'start',
          sortable: false,
          value: 'Notification'
        },
        { text: 'Mail', value: 'IsMail', sortable: true },
        { text: 'SMS', value: 'IsSMS', sortable: true },
      ],
      TextFieldRules: [
        v => !!v || 'field is required',
      ],
      ResidencyRules: [
        v => (v == 1 || v == 0) || 'field is required',
      ],
      emailRules: [
        v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
        v => !this.allUsers.map(a => a.Email).includes(v) || 'This email already belongs to a user',
        v => (v && v.length <= 100) || 'field must be less than 100 characters'
      ],
      MobileRules: [
        v => !this.allUsers.map(a => a.Mobile).includes(v) || 'This mobile already belongs to a user',
        v => (v && v.length <= 50) || 'field must be less than 50 characters'
      ],
      tab: null,
      step1_valid: true,
      step2_valid: true,
      step3_valid: true,
      step4_valid: true,
      step5_valid: true,
      SyncAddress: false,
      currentValue: 0,
      currentExceptions: [],
      Exceptions: [],
      Counters: [],
      Client: {
        Classification: 'Individual',
        exceptions: []
      },
      DateOfBirth: '',
      text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
    }
  },

  computed: {
    ...mapGetters([
      "allClients",
      "allCountries",
      "allCities",
      "allBanks",
      "allTitles",
      "allIdentityTypes",
      "allBankBranches",
      "allBankAccountTypes",
      "allCustodians",
      "allFrequencies",
      "allClientAccounts",
      "allDeliveryMethods",
      "allSectors",
      "allClientTypes",
      "allRejectionReasons",
      "allUsers",
      "currentSystemDate",
      "allConfirmationSettings",
      "allApplicationDefaults"
    ]),

    valid() {
      if (this.step1_valid == true && this.step2_valid == true && this.step3_valid == true && this.step4_valid == true && this.step5_valid == true){
        return true
      } else {
        return false
      }
    },

    currentUser() {
      return this.$store.state.auth.user;
    },
    Consultants(){
      return this.allCustodians.filter(a => a.ProfileType == 1 || a.ProfileType == 4)
    },
    IdentityTypes(){
      var types = []
      types.push(...this.allIdentityTypes)
      types.push({IdentityType: "Other", IdentityTypeID: 0, CategoryID: 0, CheckerID: -1, RejectionID: 0})
      return types
    },
    showDeleteBtn() {
    for (let i = 0; i < this.currentUser.roles.length; i++) {
      if (this.currentUser.roles[i].role_name.map(r => r.role_permission.filter(r => r.FunctionID === 302).map(r => r.AllowDelete)) == 1){
        return true
      }
    }
    return false;
    },

    showEditBtn() {
    for (let i = 0; i < this.currentUser.roles.length; i++) {
      if (this.currentUser.roles[i].role_name.map(r => r.role_permission.filter(r => r.FunctionID === 302).map(r => r.AllowEdit)) == 1){
        return true
      }
    }
    return false;
    },

    showCreateBtn() {
    for (let i = 0; i < this.currentUser.roles.length; i++) {
      if (this.currentUser.roles[i].role_name.map(r => r.role_permission.filter(r => r.FunctionID === 302).map(r => r.AllowCreate)) == 1){
        return true
      }
    }
    return false;
    },

    showConfirmBtn() {
    for (let i = 0; i < this.currentUser.roles.length; i++) {
      if (this.currentUser.roles[i].role_name.map(r => r.role_permission.filter(r => r.FunctionID === 302).map(r => r.AllowConfirm)) == 1){
        return true
      }
    }
    return false;
    },

    CheckerID(){
      if(this.allConfirmationSettings.filter(a => a.FunctionID == 302).map(a => a.Status)[0] == false){
        return this.currentUser.SecurityUserID
      } else {
        return 0
      }
    }
  },

  watch: {
    'Client.Classification': {
      handler: function(newValue) {
        if(newValue == "Individual"){
          this.DateOfBirth = this.currentSystemDate.DayDate.split('-')[0] - 20 + '-' + this.currentSystemDate.DayDate.split('-')[1] + '-' + this.currentSystemDate.DayDate.split('-')[2]
        } else {
          this.DateOfBirth = this.currentSystemDate.DayDate.split('-')[0] - 10 + '-' + this.currentSystemDate.DayDate.split('-')[1] + '-' + this.currentSystemDate.DayDate.split('-')[2]
        }
      },
      deep: true
    },
    'currentClient.BlockFlag': {
      handler: function(newValue) {
        if(newValue == true){
          this.getCurrentValue();
        } else {
          this.currentClient.BlockedValue = 0
        }
      },
      deep: true
    },
  },

  created () {
    administrationService.getEquityCounters()
    .then(response => {
      this.Counters = response.data
    })
  },

  methods: {
    ...mapActions([
      "createClient",
      "updateClient",
      "deleteClient"
    ]),

     async createNew() {
      this.message = '';
      this.loading = true;

      await this.validateStep_5()

      if (this.step5_valid == true) {
        if(this.SyncAddress == true){
          this.Client.Postal_Address_1 = this.Client.Physical_Address_1;
          this.Client.Postal_Address_2 = this.Client.Physical_Address_2;
          this.Client.Postal_Address_3 = this.Client.Physical_Address_3;
          this.Client.Postal_CountryId = this.Client.Physical_CountryId;
          this.Client.Postal_CityID = this.Client.Physical_CityID
        }
        this.Client.DateOfBirth = this.DateOfBirth,
        this.Client.NewClientMail = this.Notifications[0].IsMail,
        this.Client.NewClientSms = this.Notifications[0].IsSMS,
        this.Client.TransactionMail = this.Notifications[1].IsSMS,
        this.Client.TransactionSms = this.Notifications[1].IsSMS,
        this.Client.ReportingMail = this.Notifications[2].IsSMS,
        this.Client.ReportingSms = this.Notifications[2].IsSMS,
        this.Client.AnniversaryMail = this.Notifications[3].IsSMS,
        this.Client.AnniversarySms = this.Notifications[3].IsSMS,
        this.Client.exceptions = this.Exceptions,
        this.Client.CountryOfBirthInc = null,
        this.Client.FldInt01 = 0,
        this.Client.FldVal01 = null,
        this.Client.ExternalRef1 = null,
        this.Client.ExternalRef2 = null,
        this.Client.ExternalRef3 = null,
        this.Client.ExternalRef4 = null,
        this.Client.MakerID = this.currentUser.SecurityUserID,
        this.Client.CheckerID = this.CheckerID,
        this.Client.LastUserID = this.currentUser.SecurityUserID,
        this.Client.ModelID = 1,
        this.Client.ScripToCustodian = 1

        this.createClient(this.Client)
        .then(response =>{
          this.$socket.client.emit('socketreq', {
            commit: 'newClient',
            data: response.data
          });
          this.message = response.data.message
          this.loading = false
          this.closeCreate()
        },
        error => {
        this.loading = false
        this.message =
          (error.response && error.response.data.message) ||
          error.message ||
          error.toString();
        }) 
      }
    },

    async update() {
      this.message = '';
      this.loading = true

      await this.validateStep_5()

      if (this.step5_valid == true) {
        if(this.currentClient.CheckerID == 0){
          if(this.SyncAddress == true){
            this.currentClient.Postal_Address_1 = this.currentClient.Physical_Address_1;
            this.currentClient.Postal_Address_2 = this.currentClient.Physical_Address_2;
            this.currentClient.Postal_Address_3 = this.currentClient.Physical_Address_3;
            this.currentClient.Postal_CountryId = this.currentClient.Physical_CountryId;
            this.currentClient.Postal_CityID = this.currentClient.Physical_CityID
          }
          this.currentClient.trading_exceptions = this.currentExceptions,
          this.currentClient.LastUserID = this.currentUser.SecurityUserID,
          this.currentClient.RejectionID = this.RejectionStatus,
          this.currentClient.CheckerID = 0,
          this.currentClient.CheckDate = null,

          this.updateClient(this.currentClient)
          .then(response => {
            this.$socket.client.emit('socketreq', {
              commit: 'updClient',
              data: this.currentClient
            });
            
            this.message = response.data.message
            this.loading = false
            this.closeEdit()
          },
          error => {
          this.loading = false
          this.message =
            (error.response && error.response.data.message) ||
            error.message ||
            error.toString();
          })
        } else {
          if(this.SyncAddress == true){
            this.currentClient.Postal_Address_1 = this.currentClient.Physical_Address_1;
            this.currentClient.Postal_Address_2 = this.currentClient.Physical_Address_2;
            this.currentClient.Postal_Address_3 = this.currentClient.Physical_Address_3;
            this.currentClient.Postal_CountryId = this.currentClient.Physical_CountryId;
            this.currentClient.Postal_CityID = this.currentClient.Physical_CityID
          }
          this.currentClient.status_update = false,
          this.currentClient.trading_exceptions = this.currentExceptions,
          this.currentClient.MakerID = this.currentUser.SecurityUserID
          this.currentClient.LastUserID = this.currentUser.SecurityUserID,
          this.currentClient.RejectionID = this.RejectionStatus,
          this.currentClient.CheckerID = 0,
          this.currentClient.CheckDate = null,
          this.currentClient.MakeDate = new Date(),

          this.updateClient(this.currentClient)
          .then(response => {
            this.$socket.client.emit('socketreq', {
              commit: 'updClient',
              data: this.currentClient
            });
            
            this.message = response.data.message
            this.loading = false
            this.closeEdit()
          },
          error => {
          this.loading = false
          this.message =
            (error.response && error.response.data.message) ||
            error.message ||
            error.toString();
          })
        }
      }
    },

    deleteItem() {
      this.message = '';
      this.loading = true;
      this.deleteClient(this.currentClient)
      .then(response => {
        this.$socket.client.emit('socketreq', {
          commit: 'dltClient',
          data: this.currentClient
        });
        
        this.message = response.data.message
        this.loading = false
        this.deleteDialog = false
      },
      error => {
      this.message =
        (error.response && error.response.data.message) ||
        error.message ||
        error.toString();
        this.loading = false;
        this.deleteDialog = false
      })
    },

    updateStatus() {
      this.message = '';
      this.loading = true;

      this.currentClient.trading_exceptions = this.currentExceptions,
      this.currentClient.CheckerID = this.currentUser.SecurityUserID,
      this.currentClient.LastUserID = this.currentUser.SecurityUserID,
      this.currentClient.RejectionID = this.RejectionStatus,
      this.currentClient.status_update = true,
      this.currentClient.CheckDate = new Date(),
      this.currentClient.updatedAt = new Date(),

      this.updateClient(this.currentClient)
      .then(response => {
        this.$socket.client.emit('socketreq', {
          commit: 'updClient',
          data: this.currentClient
        });
        
        this.message = response.data.message
        this.loading = false
        this.RejectionStatus = 0;
        this.rejectionDialog = false
      },
      error => {
      this.message =
        (error.response && error.response.data.message) ||
        error.message ||
        error.toString();
        this.loading = false;
        this.RejectionStatus = 0;
        this.rejectionDialog = false
      })
    },

    getCurrentValue(){
      var data = {
        ClientID: this.currentClient.ClientID,
        CurrencyID: this.allApplicationDefaults[0].CurrencyID
      }
      administrationService.getCurrentValue(data.ClientID, data)
      .then(response => {
        this.currentValue = response.data[0].map(r => r.value)[0]
      })
    },

    generatePDF(IsPrint) {
      const addFooters = doc => {
        const pageCount = doc.internal.getNumberOfPages()

        for (var i = 1; i <= pageCount; i++) {
          doc.setPage(i)
          // text is placed using x, y coordinates
          doc.setFontSize(10).text("Clients", 0.5, 0.5);
          // create a line under heading 
          doc.setLineWidth(0.01).line(0.5, 0.6, 8.0, 0.6);
          doc.setLineWidth(0.01).line(0.5, 0.8, 8.0, 0.8);
          doc.setFontSize(6).text('Page ' + String(i) + ' of ' + String(pageCount), 4.3, 10.7, {
            align: 'center'
          })
        }
      }

      let doc = new jsPDF({
        orientation: "potrait",
        unit: "in",
        format: "letter"
      });

      doc.setFont('helvetica');
      doc.setFontSize(5);
      doc.autoTable({
        body: this.CurrentDataset,
        margin: { left: 0.5, top: 0.6 },
        styles: {overflow: 'linebreak',
                fontSize: 6},
        showHeader: 'everyPage',
        theme: 'plain'
      });
      addFooters(doc);
      if(IsPrint == true){
        doc.output('dataurlnewwindow');
      } else{
        doc.save('Clients.pdf')
      }
    },

    showMessage(){
      if(this.message){
        return true
      } else {
        return false
      }
    },

    async validateStep_1(){
      await this.$refs.step_1.validate()
        if(this.step1_valid == true){
          this.e1 = 2
        }
      return this.step1_valid
    },

    async validateStep_2(){
      await this.$refs.step_2.validate()
        if(this.step2_valid == true){
          this.e1 = 3
        }
      return this.step2_valid
    },

    async validateStep_3(){
      await this.$refs.step_3.validate()
        if(this.step3_valid == true){
          this.e1 = 4
        }
      return this.step3_valid
    },

    async validateStep_4(){
      await this.$refs.step_4.validate()
        if(this.step4_valid == true){
          this.e1 = 5
        }
      return this.step4_valid
    },

    validateStep_5(){
      this.$refs.step_5.validate()
      return this.step5_valid
    },

    syncPostalAddress () {
      this.SyncAddress = !this.SyncAddress
    },

    reset () {
      this.$refs.step_1.reset(),
      this.$refs.step_2.reset(),
      this.$refs.step_3.reset(),
      this.$refs.step_4.reset(),
      this.$refs.step_5.reset(),

      this.valid = true
    },

    getFiltered(current){
      this.CurrentDataset = current;
    },

    unconfirmed() {
      this.confirmedClients = false
    },

    showEdit () {
      this.edit = true;
      this.e1 = 1
    },

    closeEdit() {
      this.currentExceptions = [];
      this.SyncAddress = false;
      this.edit = false;
    },

    showCreate () {
      this.create = true;
      this.Client.DateOpened = this.currentSystemDate.DayDate;
      this.e1 = 1
    },

    closeCreate() {
      this.Exceptions = [];
      this.Client.DateOpened = this.currentSystemDate.DayDate;
      this.Client = {
        Classification: 'Individual',
        exceptions: []
      };
      this.SyncAddress = false;
      this.create = false;
    },

    getTitle(id) {
      return this.allTitles.filter(a => a.TitleID === id).map(a => a.Title).toLocaleString()
    },

    setActiveClient (item, index) {
      this.currentClient = item
      this.currentIndex = index

      this.currentExceptions = item.exceptions.map(e => e.CounterId)
    },
  },

  mounted () {
    UserService.isClientDetails().then(
      () => {
        this.permitted = true;
        this.message = '';
      },
      error => {
        this.permitted = false;
        this.message =
          (error.response && error.response.data.message) ||
          error.message ||
          error.toString();
      }
    );
    this.$root.$on("closeClientDialog", () => {
      this.signatories_dialog = false;
      this.contacts_dialog = false;
      this.accounts_dialog = false;
      this.kyc_dialog = false;
      this.pending = true
    });
    this.$root.$on("unconfirmedClients", () => {
      this.unconfirmed();
    });
    this.$root.$on("unconfirmedClientAccounts", () => {
      this.pending = false;
      this.accounts_dialog = true
    });
    this.$root.$on("unconfirmedClientContacts", () => {
      this.pending = false;
      this.contacts_dialog = true
    });
    this.$root.$on("unconfirmedClientSignatories", () => {
      this.pending = false;
      this.signatories_dialog = true
    });
  },
}
</script>

<style scoped>

.v-btn {
  outline: none
}

</style>